export * from './DocCheckIcon';
export * from './DocCheckIcon16Light';
export * from './DocCheckIcon16Regular';
export * from './DocCheckIcon16Solid';
export * from './DocCheckIcon20Light';
export * from './DocCheckIcon20Regular';
export * from './DocCheckIcon20Solid';
export * from './DocCheckIcon24Regular';
export * from './DocCheckIcon24Solid';
export * from './DocCheckIcon32Regular';
export * from './DocCheckIcon64Regular';
